export default {
    nombre: 'BISSTRACK',
    nombrePromo:'BISSTRACK',
    theme: {
      primary: '#795DD3' ,
      secondary: '#33355E',
      accent: '#8c9eff',
      error: '#ff5252',
    },
    features: {
      productos: {
        columnas: [
          "id_producto",
          "codigo",
          "nombre_producto",
          "categoria",
          "stock",
          "precio_estimado",
          "precio_unitario",
          "acciones"],
        botones: ['crear', 'editar', 'eliminar']
      },
      pedidosRealizados: {
        nombreTablas:{tabUno:'Pedidos Realizados', tabDos:'Mis Pedidos'},
        columnas: ["id" ,
          "vendedor" ,
          "cliente" ,
          "estado" ,
          "repartidor" ,
          "fecha" ,
          "total" ,
          "acciones"],
        botones: ['verDetalle', 'editar', 'eliminar','confirmar','asignarRepartidor','precesarPago','imprimirComanda']
      },
      gestionPedidos: {
        // Modo por defecto del tablero "Gestión de pedidos" (card #417) para
        // esta empresa; cada usuario puede cambiarlo y su elección queda
        // guardada aparte (ver src/utils/preferenciaModoGestionPedidos.js).
        modoDefault: 'completo'
      },
      usuarios: {
        columnas: ['nombre', 'apellido', 'email', 'telefono', 'id_estado', 'acciones'],
        botones: ['crear', 'editar', 'eliminar', 'resetPass']
      },
      ofertas: {
        habilitado: false
      }
    }
  };